import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/centroCosto/importer/centroCostoImporterActions';

export default importerReducers(actions);
